import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import ProtectedRoute from './components/ProtectedRoute';
import EnvironmentCheck from './components/EnvironmentCheck';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import Dashboard from './components/Dashboard';
import DraftBillOfLadingTab from './DraftBillOfLadingTab';
import theme from './theme';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <LanguageProvider>
        <EnvironmentCheck>
          <Router>
            <AuthProvider>
              <Routes>
              {/* Public Routes */}
              {/* Default route redirects to dashboard (if authenticated) or login */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              
              {/* Authentication Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />

              {/* Protected Routes - Require Authentication */}
              {/* Dashboard - Main shipment list */}
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />

              {/* BOL Draft - Create or edit BOL for a specific shipment */}
              <Route
                path="/bol/draft/:shipmentId"
                element={
                  <ProtectedRoute>
                    <DraftBillOfLadingTab />
                  </ProtectedRoute>
                }
              />

              {/* Legacy route for backward compatibility */}
              <Route
                path="/bill-of-lading"
                element={<Navigate to="/dashboard" replace />}
              />

              {/* Catch all - redirect to dashboard */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </AuthProvider>
        </Router>
      </EnvironmentCheck>
    </LanguageProvider>
  </ChakraProvider>
  );
}

export default App;
